// @flow
import React from "react"

import ButtonLink from "../ButtonLink/ButtonLink"

type Props = {
  contactText: HTMLElement | string | null,
  contactLinkText: ?string,
  contactLinkAddress: string,
}

const DelayedChatAlternativeFooter = ({
  contactText,
  contactLinkText,
  contactLinkAddress,
}: Props) => (
  <div className="DelayedChatFooter _alternative">
    {contactText && (
      <span
        className="DelayedChatFooter-content"
        dangerouslySetInnerHTML={{ __html: contactText }}
      />
    )}
    {contactLinkAddress && contactLinkText && (
      <ButtonLink
        kind="warning"
        fullwidth={!contactText}
        href={contactLinkAddress}
        iconLeft={<i className="md md-warning" />}
      >
        <span>{contactLinkText}</span>
      </ButtonLink>
    )}
  </div>
)

export default DelayedChatAlternativeFooter
